import React, { useState } from "react";
import { CustomDialog } from "../../../../CustomDialog";
import { Box } from "@material-ui/core";
import { CustomButton, CustomStepper } from "../../../../..";
import { AddNewMyLeadSteps } from "..";
import { ArrowLeftIcon } from "../../../../../../assets/icons";
import { useSelectedTheme, useTranslate } from "../../../../../../Hooks";
import { useVerticalNav } from "../../../../../../Contexts/VerticalNavContext";
import { CreateLeadWithReferredToId } from "../../../../../../Services";
import { useNewLayoutShared } from "../../../../../../Contexts/NewLayoutSharedContext";

// styles
import useStyles from "./styles";

const AddNewLeadDialog = ({
  state,
  isOpen,
  selected,
  setState,
  formType,
  reloadData,
  isQuickAdd,
  isOpenChanged,
  onSelectedChangeHandler,
  setSelected,
  translate,
}) => {

  const styles = useStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();
  const { translate: sharedTranslate } = useTranslate('SharedV2');
  const { showDialog } = useNewLayoutShared();
  const { setAlertBoxContent } = useVerticalNav();
  const itemRegex = new RegExp("^[A-Za-z ]*$");
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const [activeStep, setActiveStep] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({
    phoneError: "",
    emailError: "",
    isEmailExist: false,
    checkingEmail: false,
    firstNameError: "",
    lastNameError: "",
  });

  const cancelHandler = () => {
    isOpenChanged();
    setActiveStep(0);
  };
  const steps = [
    translate("Contact-details"),
    translate("Unit-details"),
    translate("Lead-details"),
  ];

  const validateUserInputs = () => {
    if (activeStep === 0) {
      let hasError = false;
      const errorsObj = {};
  
      if (!itemRegex.test(state.firstName)) {
        errorsObj.firstNameError = "First name must contain only letters and spaces.";
        hasError = true;
      } else {
        errorsObj.firstNameError = "";
      }
  
      if (!itemRegex.test(state.lastName)) {
        errorsObj.lastNameError = "Last name must contain only letters and spaces.";
        hasError = true;
      } else {
        errorsObj.lastNameError = "";
      }
  
      if (!state.mobileNumbers || state.mobileNumbers?.[0].length < 6) {
        errorsObj.phoneError = "Phone number must be 6 digits or more.";
        hasError = true;
      } else {
        errorsObj.phoneError = "";
      }
  
      const email = state.emailAddresses?.[0] || "";

      if (email) {
        if (!emailPattern.test(email)) {
          errorsObj.emailError = "Invalid email format";
          hasError = true;
        } else if (errors.isEmailExist) {
          errorsObj.emailError = "Duplicate Email Value With Other Contact";
          hasError = true;
        } else {
          errorsObj.emailError = "";
        }
      } else {
        errorsObj.emailError = "";
      }
  
      setErrors((prev) => ({ ...prev, ...errorsObj }));
      return hasError;
    }
    return false;
  };


  const getDisabled = () => {
    if (activeStep === 0) {
      if (
        !state.contactClassId ||
        !state.leadClassId ||
        !state.salutationId ||
        !state.firstName ||
        !state.lastName ||
        !state.languageId ||
        !state.nationalityId ||
        !state.referredBy ||
        errors?.checkingEmail
      )
        return true;
    } else if (activeStep === 1) {
      if (
        state.leadClassId &&
        (state.leadClassId === 1 || state.leadClassId === 2)
      ) {
        if (
          !state.propertyId ||
          !state.unitTypeId ||
          !state.priceFrom ||
          !state.areaFrom
        )
          return true;
      } else if (
        state.leadClassId &&
        (state.leadClassId === 3 || state.leadClassId === 4)
      ) {
        if (!state.unitTypeId || !state.priceFrom || !state.areaFrom)
          return true;
      }
    }
    if (activeStep === 2) {
      if (
        !state.leadStatusId ||
        !state.leadRatingId ||
        !state.MethodOfContact ||
        !state.mediaDetailId || (state.leadStatusId && state.leadStatusId === 458 && !state.closedReasonId ) 
      )
        return true;
    }

    return false;
  };
  const getConfirmTextValue = () => {
    if (activeStep === 0) {
      return translate("next");
    } else if (activeStep === 1) {
      return translate("next");
    } else {
      return translate("Add-lead");
    }
  };

  const onStateChangeHandler = (valueId, newValue) => {
    setState({ id: valueId, value: newValue });
  };

  const saveHandler = async () => {
    setIsSubmitted(true);
    try {
      const createObj = {
        ...state,
        areaTo: state.areaTo || 10000,
        priceTo: state.priceTo || 60000000,
      };
      const res = await CreateLeadWithReferredToId(createObj);
      if (!(res && res.status && res.status !== 200)) {
        reloadData();
        cancelHandler();
  
        setAlertBoxContent({
          display: true,
          variant: "success",
          title: translate("my-lead-added-successfully"),
          onClose: () => {
            setAlertBoxContent(null);
          },
        });

        showDialog(sharedTranslate("lead-successfully"), {
          name: res?.lead?.contact_name?.name,
          id: res?.leadId,
        });
      } else
        setAlertBoxContent({
          display: true,
          variant: "error",
          title: translate("my-lead-add-failed"),
          onClose: () => {
            setAlertBoxContent(null);
          },
        });
  
    } catch (error) {
      console.error("some Thing Wrong !")
      setAlertBoxContent({
        display: true,
        variant: "error",
        title: translate("some-thing-Wrong"),
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    } finally{
      setIsSubmitted(false)
    }

  };

  const handleOnConfirm = () => {
    if (activeStep === 0) {
      const hasErrors = (validateUserInputs());
      if (hasErrors) return; 
      setActiveStep((prevStep) => prevStep + 1);
    } else if (activeStep === 1) {
      setActiveStep((prevStep) => prevStep + 1);
    } else if (activeStep === 2) {
      saveHandler();
    }
  };
  const handleBackStep = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
  };
  return (
    <CustomDialog
      open={isOpen}
      onClose={() => {
        cancelHandler();
      }}
      title={translate("Add-new-lead")}
      width={"695px"}
      subtitle={translate(
        "Create-and-schedule-new-activity-to-enhance-engagement-with-your-contacts-and-leads"
      )}
      isDisabled={getDisabled() || isSubmitted}
      onConfirm={() => {
        handleOnConfirm();
      }}
      confirmText={getConfirmTextValue()}
      content={
        <Box className={styles.wrapperAddLeadDialog}>
          <CustomStepper activeStep={activeStep} steps={steps} />
          <AddNewMyLeadSteps
            state={state}
            selected={selected}
            formType={formType}
            isQuickAdd={isQuickAdd}
            activeStep={activeStep}
            isSubmitted={isSubmitted}
            onStateChangeHandler={onStateChangeHandler}
            onSelectedChangeHandler={onSelectedChangeHandler}
            setSelected={setSelected}
            setState={setState}
            translate={translate}
            errors={errors}
            setErrors={setErrors}
          />
        </Box>
      }
      moreAction={
        <>
          {(activeStep === 1 || activeStep === 2) && (
            <CustomButton
              boxShadow="none"
              size="lg"
              variant="text"
              color="tertiaryGray"
              startIcon={
                <ArrowLeftIcon
                  width="20"
                  height="20"
                  fill={palette.text.tertiary}
                />
              }
              onClick={() => {
                handleBackStep();
              }}
              style={{ marginInlineEnd: "auto" }}
            >
              {translate("Back")}
            </CustomButton>
          )}
        </>
      }
    />
  );
};

export default AddNewLeadDialog;
